import React, { useEffect, useState } from 'react';
import { GitBranch } from 'lucide-react';
import { api } from '../../context/AuthContext';

export const AnlageHerkunft = ({ caseId, mnr, compact = false }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const id = caseId || mnr;
  useEffect(() => {
    let alive = true; setD(null); setErr('');
    if (!id) return undefined;
    api.get(`/register/${caseId ? 'akten' : 'mandanten'}/${encodeURIComponent(id)}/herkunft`)
      .then((r) => alive && setD(r.data)).catch(() => alive && setErr('Herkunft nicht abrufbar'));
    return () => { alive = false; };
  }, [id, caseId]);
  if (!id) return null;
  return <div className="text-xs text-[#56616D] min-w-0 break-words" data-testid={`anlage-herkunft-${id}`}>
    {err ? <p role="alert" data-testid={`anlage-herkunft-fehler-${id}`}>{err}</p> : !d ? <span data-testid={`anlage-herkunft-laedt-${id}`}>Herkunft wird geladen …</span> : <>
      <p className="flex flex-wrap items-center gap-x-2 gap-y-1" data-testid={`anlage-herkunft-quelle-${id}`}><GitBranch className="w-3.5 h-3.5 shrink-0" aria-hidden="true" /><strong>{d.bezeichnung}</strong>
        <span>{d.am ? new Date(d.am).toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' }) : 'Zeitpunkt nicht hinterlegt'}</span><span>· {d.von || 'Ersteller nicht hinterlegt'}</span></p>
      {!compact && <p className="mt-1 text-[11px]" data-testid={`anlage-herkunft-nachweis-${id}`}>{d.nachweis}</p>}
      {caseId && d.fehlt?.length > 0 && <p className="mt-1 text-amber-800" data-testid={`anlage-herkunft-fehlt-${id}`}><b>Erfassung unvollständig:</b> {d.fehlt.join(', ')}</p>}
    </>}
  </div>;
};